<template>
  <div class="input-multiple-choice">
    <input-button
      v-for="(choice, key) in choices"
      :key="key"
      :class="key === 0 ? '' : 'mt-2'"
      :state="innerValue.includes(choice.value) ? 'active' : ''"
      @click="toggleValue(choice.value)"
    >
      <markdown-text>{{ getChoiceLabel(choice) }}</markdown-text>
    </input-button>
  </div>
</template>

<script>

import { mapState } from 'pinia';
import { useSurveyStore } from '@/store';
import { compareArrays } from '@/utils/arrayUtil';
import InputComponent from '../InputComponent';
import InputButton from '../common/InputButton/InputButton';
import MarkdownText from '../../common/MarkdownText';

export default {
  name: 'InputMultipleChoice',
  components: { MarkdownText, InputButton },
  extends: InputComponent,
  props: {
    modelValue: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    choices: {
      type: Array,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      innerValue: [],
    };
  },
  computed: {
    ...mapState(useSurveyStore, ['showQuestionAnswerIds']),
  },
  watch: {
    modelValue: {
      handler() {
        const newInnerValue = compareArrays(this.modelValue, this.innerValue, true);

        if (newInnerValue === true) {
          // It's already the same values
          return;
        }

        this.innerValue = newInnerValue;
      },
      deep: true,
    },
    innerValue: {
      handler() {
        const newValue = compareArrays(this.innerValue, this.modelValue, true);

        if (newValue === true) {
          // It's already the same values
          return;
        }

        this.$emit('update:modelValue', newValue);
      },
      deep: true,
    },
  },
  mounted() {
    this.innerValue = this.modelValue && this.modelValue.length ? this.modelValue : [];
  },
  methods: {
    getChoiceLabel(choice) {
      if (this.showQuestionAnswerIds) {
        return `${choice.value} - ${choice.label}`;
      }

      return choice.label;
    },
    toggleValue(value) {
      const valuePosition = this.innerValue.indexOf(value);

      if (valuePosition >= 0) {
        this.innerValue.splice(valuePosition, 1);
      } else {
        this.innerValue.push(value);
      }
    },
  },
};

</script>
